<div class="page-header">
  <div class="page-title">{{ title }}</div>

  <button *ngIf="!hideButton" mat-raised-button class="action-btn" color="primary" (click)="onClick()" [disabled]="isBtnDisabled">
    <mat-icon>{{ btnIcon }}</mat-icon
    >{{ btnLabel }}
  </button>
</div>
